import React from "react";
import CustomButton from "../ratl/utility/CustonButton";
import { ArrowRight } from "lucide-react";
import { RT_DEMO_CAL_URL } from "@/data";
import { useFloat } from "@/lib";

// Define an optional prop type for the component.
interface BookADemoProps {
  type?: string;
}

const BookADemo: React.FC<BookADemoProps> = ({ type }) => {
  const { float, handleFloat } = useFloat([false, false]);

  return (
    <CustomButton
      text="Book a Demo"
      ct="demo"
      animationRequired={false}
      bgType="solid"
      onClick={() => {
        window.location.href = RT_DEMO_CAL_URL;
      }}
      onMouseEnter={() => handleFloat(true, 1)}
      onMouseLeave={() => handleFloat(false, 1)}
      controller={float[1]}
      btnSize="small"
      isStudioBtn={false}
      className={`px-4 py-2 text-sm transition w-fit rounded-lg border-black border-[1px] ${
        type === "light"
          ? "bg-gradient-to-b from-white to-[#A3A3A3] text-black border hover:bg-gradient-to-b hover:from-[#FFFFFF]/20 hover:to-[#A3A3A3]/20 hover:text-[#E8E8E8] hover:border-[#A3A3A3]"
          : ""
      }`}
      iconPosition="right"
      iconSize={6}
      showMobile={true}
    />
  );
};

export default BookADemo;
